/**
 * 正则表达式常量
 */

/**
 * 用户名
 *
 * @type {string}
 */
export const USERNAME = '^[0-9a-zA-Z_]{1,}$'

/**
 * 角色代码
 *
 * @type {string}
 */
export const ROLE_CODE = '^[0-9a-zA-Z_]{1,}$'

/**
 * 部门代码
 *
 * @type {string}
 */
export const DEPARTMENT_CODE = '^[0-9a-zA-Z_]{1,}$'

/**
 * 权限代码
 *
 * @type {string}
 */
export const AUTHORITY_CODE = '^[0-9a-zA-Z:-]{1,}$'

/**
 * 字典编码
 *
 * @type {string}
 */
export const DICTIONARY_CODE = '^[0-9a-z_]{1,}$'

/**
 * 邮箱地址
 *
 * @type {string}
 */
export const MAIL_ADDRESS = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
